import { render } from "./ThankYouRichContent.vue?vue&type=template&id=e95b2b8a&scoped=true"
import script from "./ThankYouRichContent.vue?vue&type=script&lang=js"
export * from "./ThankYouRichContent.vue?vue&type=script&lang=js"

import "./ThankYouRichContent.vue?vue&type=style&index=0&id=e95b2b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95b2b8a"]])

export default __exports__